export default function Placeholder({ title, note }) {
  return (
    <section className="max-w-3xl mx-auto px-6 py-24" data-testid={`placeholder-${title.replace(/\s+/g, "-").toLowerCase()}`}>
      <p className="overline mb-4">Coming</p>
      <h1 className="font-display text-5xl md:text-6xl tracking-tight text-cream">{title}</h1>
      <p className="mt-6 text-cream/70 leading-relaxed max-w-lg">{note}</p>
      <div className="mt-10 hairline" />
      <p className="mt-6 text-xs text-cream/40 uppercase tracking-[0.3em]">Every decision creates more opportunity than it removes.</p>
    </section>
  );
}
